<template>
  <div class="customDetailPage">
    <Back v-if="showBack" @handleEdit="handleEdit" @handleSave="handleSave" />
    <div v-if="singlePositionData.length" class="singlePosition-box">
      <ul :class="['flex-col', `flex-col-${select}`]">
        <li
          class="col-item"
          :key="index"
          v-for="(item, index) in singlePositionData[0].modules[0].componentList"
          :class="[`col-${item.layout.proportion}`]"
        >
          <div class="title">{{ item.name }}:</div>
          <div class="val">
            <Render
              :data="item"
              :comp-name="item.renderConfig.compName"
              :renderConfig="item.renderConfig"
              :quoteMappingConfig="quoteMappingConfig"
              :value="getValue(item, formData)"
              @changeValue="value => changeValue(value, item, formData)"
              @refreshDataList="value => refreshDataList(value, item)"
              :isTxt="!isEdit"
              :positions="[...singlePositionData, ...showPositions]"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="positions-box">
      <div v-if="customerEdit" class="saveBtn">
        <template v-if="isEdit">
          <RxkButton text @click="isEdit = false">取消</RxkButton>
          <RxkButton text @click="handleSave">保存</RxkButton>
        </template>
        <RxkButton v-else text @click="handleEdit">编辑</RxkButton>
      </div>
      <template v-for="(item, index) in showPositions" :key="index">
        <template v-if="item.code === 'BLANK' && item.modules[0].show">
          <div style="padding: 0 24px; margin-bottom: 16px">
            <SubField
              v-if="item.modules && item.modules[0]?.moduleType === moduleType.subField"
              :formData="formData"
              :moduleData="item.modules[0]"
              :select="select"
              :isEdit="isEdit"
              :positions="showPositions"
              :quoteMappingConfig="quoteMappingConfig"
              :subFieldFormData="subFieldFormData"
            />
            <SubList
              :ref="(el: any) => setRefMap(el, item.modules[0])"
              :positions="showPositions"
              :quoteMappingConfig="quoteMappingConfig"
              :moduleData="item.modules[0]"
              :subListValues="subListValues"
              :deleteSublistIds="deleteSublistIds"
              :readonly="readonly"
              :subFieldFormData="subFieldFormData"
              v-if="item.modules && item.modules[0]?.moduleType === moduleType.subList"
              :data="{ tableCode: props.tableCode, id: props.dataId }"
              @save="subListSave"
            />
            <SubForm
              :formData="formData"
              :moduleData="item.modules[0]"
              :positions="showPositions"
              :columnPermission="columnPermission"
              v-if="item.modules && item.modules[0]?.moduleType === moduleType.subForm"
            />
          </div>
        </template>
        <template v-if="item.code === 'TABLE'">
          <div class="sub-table-box">
            <el-tabs class="customTabs">
              <el-tab-pane v-for="(sub, index) in item.children" :key="index" :label="sub.title">
                <template v-for="moduleItem in sub.modules" :key="moduleItem.id">
                  <div style="padding: 0 24px; margin-bottom: 16px" v-if="moduleItem.show">
                    <SubField
                      v-if="moduleItem.moduleType === moduleType.subField"
                      :formData="formData"
                      :moduleData="moduleItem"
                      :select="select"
                      :isEdit="isEdit"
                      :positions="showPositions"
                      :quoteMappingConfig="quoteMappingConfig"
                      :subFieldFormData="subFieldFormData"
                    />
                    <SubList
                      :ref="(el: any) => setRefMap(el, moduleItem)"
                      :positions="showPositions"
                      :quoteMappingConfig="quoteMappingConfig"
                      :moduleData="moduleItem"
                      :subListValues="subListValues"
                      :deleteSublistIds="deleteSublistIds"
                      :readonly="readonly"
                      :subFieldFormData="subFieldFormData"
                      v-if="moduleItem.moduleType === moduleType.subList"
                      :data="{ tableCode: props.tableCode, id: props.dataId }"
                      @save="subListSave"
                    />
                    <SubForm
                      :formData="formData"
                      :moduleData="moduleItem"
                      :columnPermission="columnPermission"
                      :positions="showPositions"
                      v-if="moduleItem.moduleType === moduleType.subForm"
                    />
                  </div>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>
      </template>
    </div>
    <div class="systemInfo-box" v-if="systemInfoList.length" style="padding: 16px 24px 16px 24px">
      <div class="title-box">
        <span class="title">系统信息</span>
      </div>
      <ul :class="['col-form-item-ul', select ? `flex-col-${select}` : '']">
        <template v-for="(item, index) in systemInfoList" :key="index">
          <li class="col-item">
            <span class="fieldName">{{ item.label }}</span>
            <div class="value-box">
              <div class="val">
                {{ item.value || '-' }}
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Back from './components/back.vue'
import { useDetail } from './hooks/useDetail'
import { fieldTypeConfig, moduleType } from '@/enums/preObjectManage'
import SubList from './components/subList.vue'
import SubField from './components/subField.vue'
import SubForm from './components/subForm.vue'
import { ref, unref, onUnmounted } from 'vue'
import { isArray, isNullOrUndefOrEmpty } from '@/utils/is'
import { cloneDeep } from '@/utils/tools'
import { formulaEmitter } from '@/utils/business/formulaEmitter'
import Render from '@/components/custom/form/components/render.vue'
import {
  dealFormValConfig,
  isMapping,
  isQuote,
  isAssociatedQuery
} from '@/utils/preObjectManage/utils'

const props = defineProps({
  showBack: {
    type: Boolean,
    default: false
  },
  customerEdit: {
    type: Boolean,
    default: false
  },
  tableCode: String,
  dataId: String,
  columnPermission: {
    type: Object,
    default: () => ({})
  },
  // 审批填写的数据
  columnValues: {
    type: Object,
    default: () => ({})
  },
  showAll: Boolean,
  subListValues: {
    type: Array,
    default: () => []
  },
  deleteSublistIds: {
    type: Array,
    default: () => []
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const {
  getDetailLayout,
  singlePositionData,
  select,
  formData,
  copyFormData,
  showPositions,
  quoteMappingConfig,
  systemInfoList,
  subFieldFormData,
  stringifyValue,
  equationList,
  visibleBox,
  layoutVisibleBox,
  associaFormCondition
} = useDetail({ ...props, id: props.dataId })
getDetailLayout()

onUnmounted(() => {
  showPositions.value.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.visibleEmitter.remove(`addVisible_${module.moduleSerial}`)
        module.componentList.forEach((field: Recordable) => {
          field.renderConfig.visibleEmitter.remove(`addVisible_${field.fieldSerial}`)
          field.renderConfig.equationEmitter.remove(`equation_${field.fieldSerial}`)
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach((child: Recordable) => {
        child.modules.forEach((module: Recordable) => {
          module.visibleEmitter.remove(`addVisible_${module.moduleSerial}`)
          module.componentList.forEach((field: Recordable) => {
            field.renderConfig.visibleEmitter.remove(`addVisible_${field.fieldSerial}`)
            field.renderConfig.equationEmitter.remove(`equation_${field.fieldSerial}`)
          })
        })
      })
    }
  })
  singlePositionData.value.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.visibleEmitter.remove(`addVisible_${module.moduleSerial}`)
        module.componentList.forEach((field: Recordable) => {
          field.renderConfig.visibleEmitter.remove(`addVisible_${field.fieldSerial}`)
          field.renderConfig.equationEmitter.remove(`equation_${field.fieldSerial}`)
        })
      })
    }
  })
})

// 获取值
function getValue(data: Recordable, form: Recordable) {
  const { code, fieldCode, fieldType } = data
  let customCode = code
  // 引用字段
  if (isQuote(fieldType)) {
    customCode = fieldTypeConfig.quote
  }
  // 映射字段
  if (isMapping(fieldType)) {
    customCode = fieldTypeConfig.mapping
  }
  const getValueFn = dealFormValConfig[customCode]
    ? dealFormValConfig[customCode].getValue
    : () => form[fieldCode] || ''
  if (data.name === '意向产品') {
    console.log(getValueFn(data, form), 'getValueFn(data, form)')
  }
  // 只要是数字，金额，百分比就去触发
  if (
    code === fieldTypeConfig.number ||
    code === fieldTypeConfig.money ||
    code === fieldTypeConfig.percentage
  ) {
    formulaEmitter(unref(equationList), data, getValueFn(data, form))
  }
  return getValueFn(data, form)
}

// 修改表单的值
function changeValue(value: any, data: Recordable, form: Recordable) {
  const { code, fieldCode } = data
  const setValueFn = dealFormValConfig[code]
    ? dealFormValConfig[code].setValue
    : () => {
        form[fieldCode] = value
      }
  setValueFn(value, data, form)

  // 如果是单选下拉或者单选按钮
  if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
    refreshVisible(data, value)
  }
  // 只要是数字，金额，百分比就去触发
  if (
    code === fieldTypeConfig.number ||
    code === fieldTypeConfig.money ||
    code === fieldTypeConfig.percentage
  ) {
    formulaEmitter(unref(equationList), data, value)
  }
}
provide('associaFormCondition', associaFormCondition)

provide('equationList', equationList)

provide('refreshVisible', refreshVisible)
function refreshVisible(field: Recordable, value: any) {
  // 处理字段的显隐
  dealVisibleControl(unref(visibleBox), field, value)
  // 处理布局的显隐
  dealVisibleControl(unref(layoutVisibleBox), field, value)
}
function dealVisibleControl(list: Recordable[], field: Recordable, value: any) {
  console.log(list, field, value, 'kkkii')
  if (unref(list).length) {
    // 接收到该字段和值，然后处理字段的显示隐藏
    // 从所有显隐规则中取出当前单选字段配置的显隐规则
    const newArr = unref(list).filter(item => item.controlSerial === field.fieldSerial)
    const cur = unref(newArr).find(item => item.value === value)
    // 如果当前值不在显隐规则中，则将该字段配置了显隐规则的全隐藏
    if (!cur) {
      unref(newArr).forEach(item => {
        if (item.controlSerial === field.fieldSerial) {
          dealVisibleData(field, item, false)
        }
      })
    } else {
      if (value) {
        const selectItem = unref(newArr).find(item => item.value === value)
        unref(newArr).forEach(item => {
          if (item.value === value) {
            dealVisibleData(field, item, true, selectItem)
          } else {
            dealVisibleData(field, item, false, selectItem)
          }
        })
      } else {
        unref(newArr).forEach(item => {
          dealVisibleData(field, item, false)
        })
      }
    }
  }
}
function dealVisibleData(
  field: Recordable,
  item: Recordable,
  bool: boolean,
  selectItem?: Recordable
) {
  const actionSerial = item.actionSerial.split(',')
  let arr: string[] = []
  if (selectItem) {
    arr = selectItem.actionSerial.split(',')
  }
  actionSerial.forEach(serial => {
    if (arr.includes(serial)) {
      field.renderConfig.visibleEmitter.emit(`detailVisible_${serial}`, true)
    } else {
      field.renderConfig.visibleEmitter.emit(`detailVisible_${serial}`, bool)
    }
  })
}

function refreshDataList(value: any, item: Recordable) {
  item.dataList = value
  item.renderConfig.dataList = value
}

const isEdit = ref(true)
function handleEdit() {
  isEdit.value = true
}
function handleSave() {
  const postData = getPostData()
  postData.groups = postData.groups.filter((item: Recordable) => item.columns.length)
  return postData
}

const refMap: Record<string, any> = {}
const setRefMap = (el: any, item: Recordable) => {
  if (el) {
    const name = `flow_subList_${item.id}`
    refMap[name] = ref(el)
  }
}
function getPostData() {
  let allUnSavaList: Recordable[] = []
  Object.keys(refMap).map(key => {
    const list = refMap[key]?.value?.unSavaList
    if (list?.length) {
      allUnSavaList = allUnSavaList.concat(list)
    }
  })

  // 判断在当前数据中，目标字段是否有未填写的情况
  const getFilledStatus = (list: Recordable[], fieldCode: string) =>
    list
      .filter(item => Object.prototype.hasOwnProperty.call(item, fieldCode))
      .some(item => {
        const val = item[fieldCode]
        const dealVal = !isNullOrUndefOrEmpty(val)
          ? isArray(val)
            ? val.join(',')
            : String(val)
          : ''
        return !dealVal
      })

  const postData: Recordable = {
    groups: [],
    subLists: [],
    type: 1,
    changeList: [],
    errorMessage: ''
  }
  const cloneData = cloneDeep([...unref(singlePositionData), ...unref(showPositions)])
  let errorMessage = ''
  // 不处理子表，子表单独保存
  cloneData.forEach((container: Recordable) => {
    console.log(container.code, 'BLANK')
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable, mIndex: number) => {
        if (module.moduleType === moduleType.subField && module.show) {
          postData.groups.push({
            moduleId: module.id,
            columns: []
          })
          module.componentList.forEach((field: Recordable) => {
            const { fieldCode, fieldType, columnQuoteInfo, code } = field
            let val = !isNullOrUndefOrEmpty(formData.value[fieldCode])
              ? isArray(formData.value[fieldCode])
                ? formData.value[fieldCode].join(',')
                : String(formData.value[fieldCode])
              : ''
            if (field.renderConfig.required && isNullOrUndefOrEmpty(val) && field.show) {
              errorMessage = errorMessage || `必填项${field.name}未填写不可审批通过`
            }
            let oldValue = !isNullOrUndefOrEmpty(unref(copyFormData)[fieldCode])
              ? unref(copyFormData)[fieldCode] + ''
              : unref(copyFormData)[fieldCode]
            const toArrayCodes = [
              fieldTypeConfig.tags,
              fieldTypeConfig.picture,
              fieldTypeConfig.enclosure
            ]
            if (toArrayCodes.includes(code)) {
              oldValue = stringifyValue(unref(copyFormData)[fieldCode] || '')
            }
            if (field.renderConfig.valCallback) {
              val = field.renderConfig.valCallback(val, field) || ''
            }
            if (
              val !== oldValue &&
              ((typeof val === 'string' && !val.includes('*')) || typeof val !== 'string')
            ) {
              postData.changeList.push({
                columnId: field.id,
                fieldSerial: field.fieldSerial,
                columnSerial: field.columnSerial,
                oldValue: oldValue,
                newValue: val
              })
            }
            if ((typeof val === 'string' && !val.includes('*')) || typeof val !== 'string') {
              const cuIndex = postData.groups.findIndex(
                (cur: Recordable) => cur.moduleId === module.id
              )

              const saveData: Recordable = {
                columnId: field.id,
                fieldSerial: field.fieldSerial,
                columnSerial: field.columnSerial,
                value: val
              }

              // 关联已有数据
              if (field.defaultMark === 1) {
                saveData.defaultQuoteDataId = field.renderConfig.defaultQuoteDataId || ''
                saveData.defaultQuoteValue = field.renderConfig.defaultQuoteValue || ''
              }

              if (field.renderConfig.id) {
                // 引用映射字段
                if (isAssociatedQuery(fieldType)) {
                  saveData.quoteTableCode = columnQuoteInfo.sourceTableCode
                  saveData.quoteColumnSerial = columnQuoteInfo.sourceColumnSerial
                  saveData.quoteDataId = field.renderConfig.id
                }
              }

              postData.groups[cuIndex].columns.push({ ...saveData })
            }
          })
        }

        // 子表单必填校验
        if (module.moduleType === moduleType.subList && module.show) {
          module.componentList.forEach((field: Recordable) => {
            const { fieldCode, name, renderConfig, show } = field
            if (renderConfig.required && show) {
              const hasNotFilled = getFilledStatus(allUnSavaList, fieldCode)
              if (hasNotFilled) {
                errorMessage = errorMessage || `必填项${name}未填写不可审批通过`
              }
            }
          })
        }
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach((child: Recordable) => {
        child.modules.forEach((module: Recordable) => {
          if (module.moduleType === moduleType.subField && module.show) {
            postData.groups.push({
              moduleId: module.id,
              columns: []
            })
            module.componentList.forEach((field: Recordable) => {
              const { fieldCode, fieldType, columnQuoteInfo, code } = field
              let val = formData.value[fieldCode]
                ? isArray(formData.value[fieldCode])
                  ? formData.value[fieldCode].join(',')
                  : String(formData.value[fieldCode])
                : ''
              if (field.renderConfig.required && isNullOrUndefOrEmpty(val) && field.show) {
                errorMessage = errorMessage || `必填项${field.name}未填写不可审批通过`
              }
              let oldValue = !isNullOrUndefOrEmpty(unref(copyFormData)[fieldCode])
                ? unref(copyFormData)[fieldCode] + ''
                : unref(copyFormData)[fieldCode]
              const toArrayCodes = [
                fieldTypeConfig.tags,
                fieldTypeConfig.picture,
                fieldTypeConfig.enclosure
              ]
              if (toArrayCodes.includes(code)) {
                oldValue = stringifyValue(unref(copyFormData)[fieldCode] || '')
              }
              if (field.renderConfig.valCallback) {
                val = field.renderConfig.valCallback(val, field) || ''
              }
              if (
                val !== oldValue &&
                ((typeof val === 'string' && !val.includes('*')) || typeof val !== 'string')
              ) {
                postData.changeList.push({
                  columnId: field.id,
                  fieldSerial: field.fieldSerial,
                  columnSerial: field.columnSerial,
                  oldValue: oldValue,
                  newValue: val
                })
              }
              if ((typeof val === 'string' && !val.includes('*')) || typeof val !== 'string') {
                const cuIndex = postData.groups.findIndex(
                  (cur: Recordable) => cur.moduleId === module.id
                )

                const saveData: Recordable = {
                  columnId: field.id,
                  fieldSerial: field.fieldSerial,
                  columnSerial: field.columnSerial,
                  value: val
                }

                // 关联已有数据
                if (field.defaultMark === 1) {
                  saveData.defaultQuoteDataId = field.renderConfig.defaultQuoteDataId || ''
                  saveData.defaultQuoteValue = field.renderConfig.defaultQuoteValue || ''
                }

                if (field.renderConfig.id) {
                  // 引用映射字段
                  if (isAssociatedQuery(fieldType)) {
                    saveData.quoteTableCode = columnQuoteInfo.sourceTableCode
                    saveData.quoteColumnSerial = columnQuoteInfo.sourceColumnSerial
                    saveData.quoteDataId = field.renderConfig.id
                  }
                }

                postData.groups[cuIndex].columns.push({ ...saveData })
              }
            })
          }

          // 子表单必填校验
          if (module.moduleType === moduleType.subList && module.show) {
            module.componentList.forEach((field: Recordable) => {
              const { fieldCode, name, renderConfig, show } = field
              if (renderConfig.required && show) {
                const hasNotFilled = getFilledStatus(allUnSavaList, fieldCode)
                if (hasNotFilled) {
                  errorMessage = errorMessage || `必填项${name}未填写不可审批通过`
                }
              }
            })
          }
        })
      })
    }
  })
  postData.errorMessage = errorMessage
  postData.subLists = unref(subLists)
  unref(subLists).forEach(subList => {
    subList.rows.forEach((row: Recordable) => {
      // 顺序保证一致
      row.columns
        .sort((a, b) => {
          let nameA = a.fieldCode.toUpperCase()
          let nameB = b.fieldCode.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })
        .forEach((col: Recordable) => {
          if (col.oldValue !== col.value) {
            postData.changeList.push({
              columnId: col.columnId,
              fieldSerial: col.columnSerial,
              columnSerial: col.columnSerial,
              oldValue: col.oldValue,
              newValue: col.value
            })
          }
        })
    })
  })
  return postData
}

// 子表单数据缓存
const subLists = ref<Recordable[]>([])
function subListSave(subList: Recordable) {
  const index = subLists.value.findIndex(item => item.moduleGroup === subList.moduleGroup)
  if (index > -1) {
    subLists.value.splice(index, 1, subList)
  } else {
    subLists.value.push(subList)
  }
}

defineExpose({
  handleSave
})
</script>
<style lang="scss" scoped>
.customDetailPage {
  background-color: #f4f4f5;
  display: flex;
  flex-direction: column;
  .singlePosition-box {
    margin-bottom: 12px;
    background-color: #fff;
    padding: 16px;
    .flex-col {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      background: #fff;
      &.flex-col-1 {
        li {
          width: 100%;
        }
      }
      &.flex-col-2 {
        li {
          width: 50%;
        }
      }
      &.flex-col-3 {
        li {
          width: 33.33%;
        }
      }
      &.flex-col-4 {
        li {
          width: 25%;
        }
      }
      .col-item {
        position: relative;
        display: flex;
        margin-bottom: 8px;
        height: 32px;
        align-items: center;
        font-size: 14px;
        padding-right: 16px;
        .title {
          color: #666666;
        }
        .val {
          flex: 1;
          color: #333333;
          padding-left: 8px;
        }
        &.col-1 {
          width: 25%;
        }
        &.col-2 {
          width: 33.33%;
        }
        &.col-3 {
          width: 50%;
        }
        &.col-4 {
          width: 66.66%;
        }
        &.col-5 {
          width: 75%;
        }
        &.col-6 {
          width: 100%;
        }
      }
    }
  }
  .positions-box {
    background-color: #fff;
    flex: 1;
    position: relative;
    .saveBtn {
      position: absolute;
      right: 24px;
      top: 0;
      color: #5687ff;
    }
  }
  :deep(.customTabs) {
    .el-tabs__nav-wrap {
      padding: 0 28px;
    }
    .el-tabs__content {
      height: auto;
    }
  }
}
.systemInfo-box {
  background: #fff;
  .title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;

    .title {
      font-size: 14px;
      color: #333333;
      font-weight: 700;
      display: inline-block;
      border-left: 3px solid #5687ff;
      padding-left: 9px;
    }
  }
  .col-form-item-ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
    > li {
      //border: 1px solid transparent;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }
    &.flex-col-1 {
      li {
        width: 100%;
        &:nth-child(1) {
          border-top: 1px solid #ebeef5;
        }
      }
    }
    &.flex-col-2 {
      li {
        width: 50%;
        &:nth-child(-n + 2) {
          border-top: 1px solid #ebeef5;
        }
      }
    }
    &.flex-col-3 {
      li {
        width: 33.33%;
        &:nth-child(-n + 3) {
          border-top: 1px solid #ebeef5;
        }
      }
    }
    &.flex-col-4 {
      li {
        width: 25%;
        &:nth-child(-n + 4) {
          border-top: 1px solid #ebeef5;
        }
      }
    }

    .col-item {
      display: flex;
      .value-box {
        width: calc(100% - 140px);
      }
      .fieldName {
        font-size: 14px;
        color: #333;
        height: 100%;
        display: flex;
        min-height: 40px;
        align-items: center;
        width: 140px;
        background-color: #f4f4f5;
        padding-left: 8px;
        flex-shrink: 0;
      }
      &.col-1 {
        width: 25%;
      }

      &.col-2 {
        width: 33.33%;
      }

      &.col-3 {
        width: 50%;
      }

      &.col-4 {
        width: 66.66%;
      }

      &.col-5 {
        width: 75%;
      }

      &.col-6 {
        width: 100%;
      }

      .val {
        height: 100%;
        padding: 10px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #333333;
        word-break: break-all;
      }
    }
  }
}
</style>
